import { GET_POLICY_SUMMARY } from '../../constants/actions/policy';

export function getPolicySummary() {
    return {
        type: GET_POLICY_SUMMARY,
    };
}
